import React from 'react'
import WhaleImage from '../../static/amort_whale.png'
import KeyImage from '../../static/key5.png'
import KeyImageRu from '../../static/key5_ru.png'
import CurrentLanguageContext from 'src/context/currentLanguageContext';

function svgTag(keyImage, id, height, width, whaleX, whaleY, cardX, cardY, transition,
    svgKeyWidth = 442, svgKeyHeight = 259, whaleWidth = 80, whaleHeight = 44, maskHeight = 95, maskWidth = 215) {
    return `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="gray" style="width: ${width}px; height: ${height}px; max-width: 100%">
      <symbol id="${id}s-mask-circles">
          <g fill="white">
              <rect id="${id}glassrect" x="${whaleX}" y="${whaleY}" width="${maskWidth}" height="${maskHeight}" r="10"
                    style="${transition ? 'transition: y .2s ease;' : ''}stroke: none; "></rect>
          </g>
      </symbol>
      <mask id="${id}mask-circles">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${id}s-mask-circles"></use>
      </mask>
      <symbol id="${id}s-flower-m" style="opacity:1;transition: all 60ms ease">
          <image xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href=${WhaleImage} width="${whaleWidth}" height="${whaleHeight}"
                x="${whaleX}" y="${whaleY}" ></image>
      </symbol>
      <g>
          <image id="${id}svgkey" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href=${keyImage} width="${svgKeyWidth}px"
                 height="${svgKeyHeight}px" x="${cardX}" y="${cardY}" style="${transition ? 'transition: y .2s ease;' : ''}"></image>
          <g mask="url(#${id}mask-circles)">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${id}s-flower-m"></use>
          </g>
      </g>
    </svg>
  `
}

const svgKey = (props) => {
    const { id, height, width, whaleX, whaleY, cardX, cardY, transition, svgKeyWidth, svgKeyHeight, whaleWidth, whaleHeight, maskHeight, maskWidth } = props
    return (
        <CurrentLanguageContext.Consumer>
            {currentLanguage => {
                return <div
                    {...props}
                    dangerouslySetInnerHTML={{
                        __html: svgTag(
                            currentLanguage == 'ru' ? KeyImageRu : KeyImage, id, height, width, whaleX, whaleY, cardX, cardY, transition, svgKeyWidth, svgKeyHeight, whaleWidth, whaleHeight, maskHeight, maskWidth
                        )
                    }}
                />
            }}
        </CurrentLanguageContext.Consumer>
    )
}

export default svgKey



// WEBPACK FOOTER //
// ./src/finwhale/amort/svgKey.js